export const TEST_BRANCH_BASE = "/branchtest";
export const LIVE_BRANCH_BASE = "/huffmanteam";
export const NETLIFY_BRANCH_BASE = "/";
export const DEV_GRAPHQL_API_URL = "http://localhost:4000";
export const LIVE_GRAPHQL_API_URL = "https://graphql-onetrust.herokuapp.com/";
export const TEST_GRAPHQL_API_URL = "https://graphql-test-lime.now.sh/";
export const THANK_YOU_PAGE_URL =
  "https://onetrusthomeloans.com/thank-you-for-your-request";
